<template>
  <el-dialog title="答卷详情" top="30vh" custom-class="ui-box-dialog" :visible.sync="dialogVisible" width="700px" :before-close="dialogBeforeClose">
    <div v-for="(item,index) in answers" :key="index" style="margin-bottom:20px">
      <div style="margin-bottom:5px">{{`${item.tbSort}、${item.tbQuestionnaireName}  (${typeMap[item.tbType]})`}}</div>
      <div>{{`答：${item.tbAnswerContent}${(item.tbOtherContent&&item.tbOtherContent.length)?'('+item.tbOtherContent+')':''}`}}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="ui-box-cancel" @click="dialogBeforeClose">取 消</el-button>
      <el-button class="ui-box-submit" type="primary" @click="dialogBeforeClose">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'anwserDialog',
  props: {
    answers: {
      type: Array
    },
    dialogVisible: {
      type: Boolean
    }
  },
  data () {
    return {
      typeMap: {
        1: '单选题',
        2: '多选题',
        3: '判断题',
        5: '简答题'
      }
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {

    dialogBeforeClose () {
      this.$emit('update:dialogVisible', false)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ui-box-dialog {
  border-radius: 12px;
  ::v-deep .el-dialog__title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
  }
  ::v-deep .el-dialog__headerbtn {
    &:focus {
      outline: none;
    }
  }
  .ui-box-from-questionnaireDetail {
    padding-top: 29px;
    ::v-deep .el-form-item {
      margin-top: 24px;
      margin-bottom: 0;
      ::v-deep .el-form-item__label {
        height: 32px;
        line-height: 32px;
        padding: 0;
        margin: 0;
      }
      ::v-deep .el-form-item__error {
        padding-left: 20px;
      }
      ::v-deep .el-form-item__content {
        height: 100%;
        padding-left: 20px;
        line-height: 32px;
      }
      .remove {
        color: #f56c6c;
        margin-left: 10px;
      }
      .width645 {
        width: 645px;
      }
      .ui-box-from-questionnaireDetail-input {
        width: 500px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.width645 {
          width: 645px;
        }
        ::v-deep .el-icon-time,
        ::v-deep .el-icon-arrow-down,
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-icon-date,
        ::v-deep .el-icon-date,
        ::v-deep .el-range__icon,
        ::v-deep .el-range-separator,
        ::v-deep .el-range-input,
        ::v-deep .el-range__close-icon,
        ::v-deep .el-icon-circle-close,
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-icon-date,
        ::v-deep .el-input__inner {
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          border: none;
        }
        ::v-deep .el-input__inner::-webkit-outer-spin-button,
          // eslint-disable-next-line no-irregular-whitespace
          ::v-deep .el-input__inner::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        ::v-deep .el-input__inner[type="number"] {
          -moz-appearance: textfield;
        }
        ::v-deep .el-input-group__prepend {
          background-color: #fff;
          height: 30px;
          border: none;
          &::-moz-placeholder,
          &::-webkit-input-placeholder,
          &::-ms-input-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #cccccc;
          }
          ::v-deep .el-select {
            width: 130px;
            margin: 0 -15px;
            border-right: 1px solid rgba(0, 0, 0, 0.15);
          }
        }
        ::v-deep .el-input-group__prepend {
          padding: 0 15px;
        }
      }
    }
  }
  .ui-box-cancel {
    padding: 7px 26px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #555555;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
  .ui-box-submit {
    padding: 7px 26px;
    background: #3d7fff;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
}

::v-deep .ui-box-dialog {
  border-radius: 12px;
  .el-dialog__title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
  }
  .el-dialog__headerbtn {
    &:focus {
      outline: none;
    }
  }
  .ui-box-from-questionnaireDetail {
    padding-top: 29px;
    .el-form-item {
      margin-top: 24px;
      margin-bottom: 0;
      .ui-box-tableList-img {
        width: 80px;
        height: 80px;
        background: #d8d8d8;
        display: inline-block;
        vertical-align: top;
      }
      &.inline {
        display: inline-block;
        vertical-align: top;
      }
      &.height-auto {
        .el-form-item__content {
          height: auto;
        }
      }

      .el-form-item__label {
        height: 32px;
        line-height: 32px;
        padding: 0;
        margin: 0;
      }
      .el-form-item__error {
        padding-left: 20px;
      }
      .el-form-item__content {
        height: 100%;
        padding-left: 20px;
        line-height: 32px;
      }
      .addOption {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #1890ff;
      }
      .width645 {
        width: 645px;
      }
      .remove {
        color: #f56c6c;
        margin-left: 10px;
      }
      .ui-box-from-questionnaireDetail-input {
        width: 500px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.width645 {
          width: 645px;
        }
        .el-icon-time,
        .el-icon-arrow-down,
        .el-icon-arrow-up,
        .el-icon-date,
        .el-icon-date,
        .el-range__icon,
        .el-range-separator,
        .el-range-input,
        .el-range__close-icon,
        .el-icon-circle-close,
        .el-icon-arrow-up,
        .el-icon-date,
        .el-input__inner {
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          border: none;
        }
        .el-input__inner::-webkit-outer-spin-button,
        .el-input__inner::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        .el-input__inner[type="number"] {
          -moz-appearance: textfield;
        }
        .el-input-group__prepend {
          background-color: #fff;
          height: 30px;
          border: none;
          &::-moz-placeholder,
          &::-webkit-input-placeholder,
          &::-ms-input-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #cccccc;
          }
          .el-select {
            width: 130px;
            margin: 0 -15px;
            border-right: 1px solid rgba(0, 0, 0, 0.15);
          }
        }
        .el-input-group__prepend {
          padding: 0 15px;
        }
      }
    }
  }
  .ui-box-cancel {
    padding: 7px 26px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #555555;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
  .ui-box-submit {
    padding: 7px 26px;
    background: #3d7fff;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
}
</style>